<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import RichTextEditor from '@/components/RichTextEditor.vue';
import { required } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'User Profile',
		meta: [
			{
				name: 'User Profile',
			},
		],
	},
	components: { RichTextEditor },
	props: ['userId', 'userTypeId', 'userName', 'userEmail', 'userLocationId'],
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			autoClose: '',
			attendWorship: '',
			isKnowApplicant: '',
			cooperation: '',
			options: ['Yes', 'No'],
			preservePage: 1,
			pageLimit: 10,
			status: ['Active', 'InActive'],
			currentUserData: JSON.parse(localStorage.getItem('user')),
			tags: null,
			comments: null,
			commentForm: {
				user_id: this.user_id,
				comment: '',
				commenter_id: '',
				tag_id: '',
			},
			tagForm: {
				name: '',
			},
			searchForm: {
				tag: '',
				commenter: '',
			},
			isTag: false,
			isCommenter: false,
			isSearching: false,
			isLoading: false,
			noRecord: false,
			searchBy: '',
			isUpdate: false,
			isAdd: false,
			typeSubmit: false,
			modalTitle: '',
			commentId: '',
			emailForm: {
				user_id: this.userId,
				type: '',
				staff_id: '',
				to: '',
				cc: '',
				comment: '',
				subject: '',
				rt: '',
			},
			isInStateUser: false,
		};
	},
	validations: {
		commentForm: {
			comment: '',
			tag_id: '',
		},
		tagForm: {
			name: { required },
		},
	},
	mounted() {
		this.getComments();
		this.calculateUserProps();
	},
	methods: {
		getComments(page) {
			this.isLoading = true;
			this.noRecord = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			let userId = '&user_id=' + this.userId;
			if (this.searchForm.tag) {
				filter += '&tag=' + this.searchForm.tag;
			}
			if (this.searchForm.commenter) {
				filter += '&commenter=' + this.searchForm.commenter;
			}
			axios.get('admin/user/comments?pagination=true&page=' + page + filter + userId).then((res) => {
				this.comments = res.data.response;
				this.isLoading = false;
				if (!this.comments.data.length) {
					this.noRecord = true;
					if (page > 1) {
						this.getComments(page - 1);
					}
				}
			});
		},

		getTags() {
			axios.get('admin/tags?pagination=true&per_page=1000').then((res) => {
				this.tags = res.data.response.data;
			});
		},

		showTagModal() {
			this.typeSubmit = false;
			this.$bvModal.show('tagModal');
			this.tagForm = {
				name: '',
			};
		},

		addTag() {
			this.typeSubmit = true;
			// stop here if form is invalid
			this.$v.$touch();
			if (!this.$v.tagForm.$invalid) {
				var token = localStorage.getItem('token');
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					axios
						.post('admin/tags', this.tagForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'Tag added successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.$bvModal.hide('tagModal');
								this.tagForm = {
									name: '',
								};
								this.typeSubmit = false;
							}
						})
						.catch((err) => {
							if (err.response) {
								Swal.fire({
									title: 'Error!',
									text: err.response.data.error.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		showEditModal(comment) {
			this.getTags();
			this.modalTitle = 'Edit Comment';
			this.$bvModal.show('commentModal');
			this.commentForm.comment = comment.comment;
			this.commentForm.tag_id = comment.tag_id;
			this.commentForm.commenter_id = this.currentUserData.id;
			this.commentForm.user_id = this.userId;
			this.commentId = comment.id;
			this.isUpdate = true;
			this.isAdd = false;
		},

		showAddModal() {
			this.getTags();
			this.typeSubmit = false;
			this.modalTitle = 'Add Comment';
			this.$bvModal.show('commentModal');
			this.isAdd = true;
			this.isUpdate = false;
			this.commentForm = {
				comment: '',
				tag_id: '12',
			};
		},

		updateComment() {
			this.typesubmit = true;
			this.$v.$touch();
			if (!this.$v.commentForm.$invalid) {
				var token = localStorage.getItem('token');
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					axios
						.patch('admin/user/comments/' + this.commentId, this.commentForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'Comment updated successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.getComments();
								this.typeSubmit = false;
								this.$bvModal.hide('commentModal');
								this.commentForm = {
									comment: '',
									tag_id: '',
								};
							}
						})
						.catch((err) => {
							if (err.response) {
								Swal.fire({
									title: 'Error!',
									text: err.response.data.error.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		showEmailModal(tag, type, assignedId) {
			let emailTag = this.isInStateUser ? `in_${tag}` : tag;
			this.emailForm.comment = '';
			this.emailForm.cc = '';
			this.emailForm.subject = '';
			this.emailForm.to = this.userEmail;
			this.emailForm.type = emailTag;
			this.commentForm.staff_id = assignedId;
			this.recordNotFound = false;
			this.isLoading = true;

			this.modalTitle = 'Send Email';
			this.$bvModal.show('emailModal');
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('admin/email_templates/by_tag?type=' + type + '&tag=' + emailTag, config)
					.then((res) => {
						if (res.status == '200') {
							this.isLoading = false;
							this.emailForm.comment = res.data.response.body;
							this.emailForm.subject = res.data.response.subject;
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response);
						}
					});
			}
		},

		sendEmail() {
			var token = localStorage.getItem('token');
			var user = JSON.parse(localStorage.getItem('user'));
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			this.isLoading = true;
			this.emailForm.user_id = this.userId;
			this.emailForm.approval_id = 0;
			this.emailForm.staff_id = user.id;
			this.emailForm.rt = user.email;
			if (token) {
				axios
					.post('admin/user/approvals/email', this.emailForm, config)
					.then((res) => {
						this.isLoading = false;
						if (res.status == '200') {
							Swal.fire({
								title: 'Success!',
								text: 'Email sent successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.$bvModal.hide('emailModal');
							this.getComments();
							this.emailForm = {
								user_id: this.user_id,
								staff_id: '',
								comment: '',
								cc: '',
								subject: '',
								type: '',
							};
						}
					})
					.catch((err) => {
						this.isLoading = false;
						if (err.response) {
							Swal.fire({
								title: 'Error!',
								text: err.response.data.error.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			}
		},

		deleteComment(commendId) {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				Swal.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#34c38f',
					cancelButtonColor: '#f46a6a',
					confirmButtonText: 'Yes, delete it!',
				}).then((result) => {
					if (result.value) {
						console.log(commendId);
						axios
							.delete('admin/user/comments/' + commendId, config)
							.then((res) => {
								if (res.status == '200') {
									Swal.fire({
										title: 'Deleted!',
										text: 'Your comment has been deleted!',
										icon: 'success',
										width: 350,
										showConfirmButton: false,
										timer: 1500,
									});
									this.getComments();
								}
							})
							.catch((err) => {
								if (err.response) {
									Swal.fire({
										title: 'Error!',
										text: err.response.data.error.message,
										icon: 'error',
										width: 350,
										showConfirmButton: true,
									});
								}
							});
					}
				});
			}
		},

		addComment() {
			this.typeSubmit = true;
			this.$v.$touch();
			if (!this.$v.commentForm.$invalid) {
				var token = localStorage.getItem('token');
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					this.commentForm.commenter_id = this.currentUserData.id;
					this.commentForm.user_id = this.userId;
					axios
						.post('admin/user/comments', this.commentForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'Comment added successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.$bvModal.hide('commentModal');
								this.commentForm = {
									comment: '',
									tag_id: null,
								};
								this.typeSubmit = false;
								this.getComments();
							}
						})
						.catch(async (err) => {
							if (err.response) {
								await Swal.fire({
									title: 'Error!',
									text: err?.response?.data?.error?.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		searchOption(event) {
			this.searchForm = {
				tag: '',
				commenter: '',
			};
			let selectedValue = event.target.value;
			if (selectedValue == '') {
				this.resetSearch();
			}
			if (selectedValue == 'tag') {
				this.isTag = true;
				this.isCommenter = false;
				this.isSearching = true;
			}
			if (selectedValue == 'commenter') {
				this.isTag = false;
				this.isCommenter = true;
				this.isSearching = true;
			}
		},

		searchComments() {
			this.getComments();
		},

		resetSearch() {
			this.searchForm = {
				tag: '',
				commenter: '',
			};
			this.isSearching = false;
			this.isTag = false;
			this.isCommenter = false;
			this.searchBy = '';
			this.getComments();
		},

		getFullName(user) {
			let fullName = '';
			if (user.first_name && user.first_name.length) {
				fullName += user.first_name;
			}
			if (user.last_name && user.last_name.length) {
				fullName += ' ' + user.last_name;
			}
			return fullName;
		},

		calculateUserProps() {
			let component = this;
			if (!component.userLocationId) {
				return;
			}

			let minneapolisLocationId = 2;
			component.isInStateUser = component.userLocationId == minneapolisLocationId ? true : false;
		},
	},
};
</script>

<template>
	<div>
		<div class="d-flex align-items-center justify-content-space">
			<div v-if="userTypeId == 3" class="mb-4 mdl-btns">
				<b-button size="sm" class="mx-1" @click="showEmailModal('nearing_completion', 'mentor')" variant="primary">Nearing Completion</b-button>
				<b-button size="sm" class="mx-1" @click="showEmailModal('commitment_completion', 'mentor')" variant="primary">Commitment Completion</b-button>
				<b-button size="sm" class="mx-1" @click="showEmailModal('recent_residence_reassignment', 'mentor')" variant="primary">Mentor Reassignment</b-button>
				<b-button size="sm" @click="showEmailModal('volunteer_becoming_mentor', 'mentor')" variant="primary">Volunteer becoming Mentor</b-button>

				<b-modal id="emailModal" centered :title="modalTitle" title-class="font-18" hide-footer>
					<form>
						<div class="mb-3">
							<label>To</label>
							<input v-model="emailForm.to" class="form-control" name="to" placeholder="To" readonly />
						</div>

						<div class="mb-3">
							<label>CC</label>
							<input v-model="emailForm.cc" class="form-control" name="cc" placeholder="CC (comma separated)" />
						</div>

						<div class="mb-3">
							<label>Subject</label>
							<input v-model="emailForm.subject" class="form-control" name="subject" placeholder="Subject" />
						</div>

						<div class="mb-3">
							<label>Body</label>
							<RichTextEditor cssClasses="form-control" v-model="emailForm.comment" />
						</div>

						<div class="mb-0">
							<div>
								<button type="button" @click="sendEmail" class="btn btn-primary" :disabled="isLoading">
									Send
									<i class="fab fa-telegram-plane ms-1"></i>
								</button>
							</div>
						</div>
					</form>
				</b-modal>
			</div>
			<div class="mb-4 mdl-btns ms-auto">
				<!--Add New Tag-->
				<b-button size="sm" @click="showTagModal" variant="primary">Add New Tag</b-button>

				<b-modal id="tagModal" centered title="Add New Tag" title-class="font-18" hide-footer>
					<div class="mb-3">
						<label>Tag</label>
						<input
							v-model="tagForm.name"
							type="text"
							class="form-control"
							placeholder="Enter New Tag"
							:class="{
								'is-invalid': typeSubmit && $v.tagForm.name.$error,
							}"
						/>
						<div v-if="typeSubmit && $v.tagForm.name.$error" class="invalid-feedback">
							<span v-if="!$v.tagForm.name.required">Tag name is required.</span>
						</div>
					</div>

					<div class="mb-0">
						<div>
							<button @click="addTag" class="btn btn-primary">Add New Tag</button>
						</div>
					</div>
				</b-modal>

				<!--Add New Comment Modal-->
				<b-button size="sm" @click="showAddModal" variant="primary">Add Comment</b-button>
				<b-modal id="commentModal" centered :title="modalTitle" title-class="font-18" hide-footer>
					<form>
						<div class="mb-3">
							<label>Comment</label>
							<div>
								<textarea
									v-model="commentForm.comment"
									class="form-control"
									name="comment"
									rows="3"
									placeholder="Enter Comment"
									:class="{
										'is-invalid': typeSubmit && $v.commentForm.comment.$error,
									}"
								></textarea>
								<div v-if="typeSubmit && $v.commentForm.comment.$error" class="invalid-feedback">
									<span v-if="!$v.commentForm.comment.required">Comment is required.</span>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<label class="mt-0">Select Tags</label>
							<b-form-select class="form-select" v-model="commentForm.tag_id" :options="tags" value-field="id" text-field="name" :class="{ 'is-invalid': typeSubmit && $v.commentForm.tag_id.$error }">
								<option slot="first" :value="null" disabled>Select Tag</option>
							</b-form-select>
							<div v-if="typeSubmit && $v.commentForm.tag_id.$error" class="invalid-feedback">
								<span v-if="!$v.commentForm.tag_id.required">Tag is required.</span>
							</div>
						</div>

						<div class="mb-0">
							<div>
								<button type="button" v-if="isAdd" @click="addComment" class="btn btn-primary">Add Comment</button>
								<button type="button" v-if="isUpdate" @click="updateComment" class="btn btn-primary">Update Comment</button>
							</div>
						</div>
					</form>
				</b-modal>
			</div>
		</div>

		<form class="row align-items-center form-inline mb-4 border p-3 m-0">
			<div class="col-md-12">
				<h4 class="font-size-14">Search By:</h4>
			</div>
			<div class="col-md-4">
				<select class="form-select custom-select" v-model="searchBy" @change="searchOption($event)">
					<option value="">Select Option</option>
					<option value="tag">Tag</option>
					<option value="commenter">Commenter</option>
				</select>
			</div>
			<div class="col-md-2 sm-hidden xs-hidden"></div>
			<div class="col-md-6 pull-right">
				<div class="row app-search pt-0 pb-0">
					<div class="col-md-12 d-flex">
						<input v-if="isTag" v-model="searchForm.tag" type="text" class="ps-4 form-control" placeholder="Type Tag" />
						<input v-if="isCommenter" v-model="searchForm.commenter" type="text" class="ps-4 form-control" placeholder="Type Commenter Name" />

						<b-button v-if="isSearching" id="show-btn" class="btn-find" @click="searchComments" variant="primary" title="Search">
							<i class="bx bx-search-alt-2"> Search</i>
						</b-button>

						<b-button v-if="isSearching" class="btn-reset ms-2" id="show-btn" @click="resetSearch" variant="primary" title="Reset">
							<i class="bx bx-reset"> Reset</i>
						</b-button>
					</div>
				</div>
			</div>
		</form>

		<div class="row mt-3">
			<div v-if="noRecord">
				<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
			</div>

			<div v-if="isLoading" class="text-center">
				<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
			</div>

			<div class="col-md-12 px-0 cards-cont" v-else>
				<div v-if="this.comments">
					<b-card class="border border-2 shadow-none" v-for="(comment, index) in this.comments.data" :key="index">
						<h5 slot="header" class="mb-0">
							{{ comment.commenter.first_name != null ? getFullName(comment.commenter) : comment.commenter.email }}
							<p class="font-size-13 mb-0 ms-5 fw-bold d-inline-block">
								{{ new Date(comment.created_at).toLocaleString() }}
								<span class="fst-italic fw-light ms-3">{{ comment.tag }}</span>
							</p>

							<p class="mb-0 float-end icons-wrap">
								<a href="javascript:;" @click="showEditModal(comment)" class="text-dark"><i class="bx bxs-pencil"></i></a>
								<a href="javascript:;" @click="deleteComment(comment.id)" class="ms-1 text-dark"><i class="bx bx-x font-size-24"></i></a>
							</p>
						</h5>
						<div class="card-text" v-html="comment.comment"></div>
					</b-card>
				</div>
				<pagination v-if="comments != null" class="mt-4" :data="comments" :limit="10" @pagination-change-page="getComments"></pagination>
			</div>
		</div>
	</div>
</template>
<style scoped>
.mdl-btns button:nth-child(1) {
	margin-right: 1rem;
}

.icons-wrap {
	position: absolute;
	top: 7px;
	right: 10px;
	display: flex;
}

.icons-wrap a:first-child {
	margin-top: 4px;
}

.cards-cont .card:nth-child(odd) .card-header {
	background-color: #32b1f9;
}

.app-search input,
.app-search select {
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
}

.app-search .btn-find {
	width: 40%;
	border-top-right-radius: 30px;
	border-bottom-right-radius: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	box-shadow: none;
}

.app-search .btn-reset {
	width: 40%;
	font-size: 15px;
	box-shadow: none;
	border-radius: 30px;
}
</style>
